import { FC, ReactNode } from 'react';
import { DigitalFormsFreemiumWrapper, DigitalFormsLocationsWrapper } from '@frontend/digital-forms-scope';
import { UseSendFormsProvidersProps } from './hooks';
import SendFormsMain from './main';
import { SendFormsStoreProvider } from './store';

type SendFormsWrapperProps = UseSendFormsProvidersProps & {
  children: ReactNode;
};

export const SendFormsWrapper: FC<SendFormsWrapperProps> = ({ children, ...props }) => {
  return (
    <DigitalFormsFreemiumWrapper>
      <DigitalFormsLocationsWrapper>
        <SendFormsStoreProvider>
          <SendFormsMain {...props}>{children}</SendFormsMain>
        </SendFormsStoreProvider>
      </DigitalFormsLocationsWrapper>
    </DigitalFormsFreemiumWrapper>
  );
};
